import {Actions} from "consent/actions";
import {Actions as UserFormActions} from "userform/actions";
import {
    IActiveConsent,
    IDocAppointment,
    ILoanApprovalInfo,
    IProfile,
    IOppSubstatus,
    IConsentProcessMode, INach,
} from "StateInterface";
import {IFlaggedState} from "../reducers/flagTools";
import {Flags} from "../reducers/flagActions";
import {EventName, updateConsentEvent} from "consent/events";
import {Actions as ProfileAction} from "profile/actions";

export interface IState extends IFlaggedState<Flags> {
    consent: IActiveConsent;
    isChequeAvailable: boolean;
    loading: boolean;
    docAppointment: IDocAppointment;
    flags: Flags[];
    nightingalesFlags: Flags[];
    loanApprovalInfo: ILoanApprovalInfo;
    unsignedDocBase64Str: string;
    esignResponse: boolean;
    isAndroid: boolean;
    flagsV3: Flags[];
    profileStatus: IProfile;
    initiationNachError: string;
    initialLoginChannel: string;
    latestStatus: boolean;
    consentProcessMode: IConsentProcessMode;
    lenderOpportunityId: string;
    addDelay: object;
}

const defaultState: IState = {
    consent: null,
    isChequeAvailable: null,
    loading: false,
    docAppointment: null,
    flags: [],
    nightingalesFlags: [],
    loanApprovalInfo: null,
    unsignedDocBase64Str: null,
    esignResponse: null,
    isAndroid: false,
    flagsV3: [],
    profileStatus: null,
    initiationNachError: null,
    initialLoginChannel: null,
    latestStatus: false,
    consentProcessMode: null,
    lenderOpportunityId: null,
    addDelay: null,
};
let consentFlow = false;
export default function consent(state = defaultState, action) {
    let flags = [];
    let loanApprovalInfo = null;
    switch (action.type) {
        case Actions.REQUEST_GET_OPP_ID:
            return {
                ...state,
                loading: true,
            }
        case `${Actions.REQUEST_GET_OPP_ID}_SUCCESS`:
            return {
                ...state,
                loading: false,
                lenderOpportunityId: action.body.active_opp_id
            }
        case Actions.REQUEST_LOAN_OPP:
            return {
                ...state,
                loading: true,
            }
        case `${Actions.REQUEST_LOAN_OPP}_SUCCESS`:
            flags = [nextFlag(action.body, state.unsignedDocBase64Str)];
            return {
                ...state,
                loading: false,
                loanApprovalInfo: action.body,
                latestStatus: true,
                flags,
            }
        case ProfileAction.SET_PAANDU_PROFILE:
        return {
            ...state,
            profileStatus: action.body.profileData,
        };
        case Actions.REQUEST_SAVE_DOCUMENTS_CONSENT:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_SAVE_DOCUMENTS_CONSENT}_SUCCESS`:
            loanApprovalInfo = Object.assign({}, state.loanApprovalInfo);
            loanApprovalInfo.documentsConsentStatus = action.payload.service.body;
            flags = [nextFlag(loanApprovalInfo, state.unsignedDocBase64Str)];
            consentFlow = true;
            return {
                ...state,
                loading: false,
                loanApprovalInfo,
                latestStatus: false,
                flags,
            };
        case Actions.REQUEST_SAVE_DOCUMENTATION_MODE:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_SAVE_DOCUMENTATION_MODE}_SUCCESS`:
            loanApprovalInfo = Object.assign({}, state.loanApprovalInfo);
            flags = [nextFlag(loanApprovalInfo, state.unsignedDocBase64Str)];
            consentFlow = true;
            return {
                ...state,
                loanApprovalInfo,
                flags,
                loading: false,
                latestStatus: false,
            };
        case Actions.REQUEST_GET_UNSIGNED_DOCUMENT:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_GET_UNSIGNED_DOCUMENT}_SUCCESS`:
            return {
                ...state,
                unsignedDocBase64Str: action.body.unsignedDoc,
                latestStatus: false,
            };
        case `${Actions.REQUEST_GET_UNSIGNED_DOCUMENT}_FAILURE`:
            return {
                ...state,
                loading: false,
            };
        case Actions.REQUEST_GET_ESIGN_OTP:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_GET_ESIGN_OTP}_SUCCESS`:
            return {
                ...state,
                loading: false,
            };
        case Actions.REQUEST_VERIFY_ESIGN_OTP:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_VERIFY_ESIGN_OTP}_SUCCESS`:   
            return {
                ...state,
                addDelay: action.body,
            }
        case Actions.CLEAR_DELAY :
            updateConsentEvent(EventName.SIGN_LOAN_AGREEMENT, true);
            loanApprovalInfo = Object.assign({}, state.loanApprovalInfo);
            loanApprovalInfo.isEsignDone = action.body.status;
            flags = [nextFlag(loanApprovalInfo, state.unsignedDocBase64Str)];
            consentFlow = true;
            return {
                ...state,
                loading: false,
                addDelay: null,
                loanApprovalInfo,
                flags,
                esignResponse: action.body.status,
                latestStatus: false,
            };
        case `${Actions.REQUEST_VERIFY_ESIGN_OTP}_FAILURE`:
            updateConsentEvent(EventName.SIGN_LOAN_AGREEMENT, false);
            return {
                ...state,
                loading: false,
                esignResponse: false,
                latestStatus: false,
            };
        case `${Actions.END_TIMER}`:
            flags = state.unsignedDocBase64Str ? [nextFlag(state.loanApprovalInfo, state.unsignedDocBase64Str)] : [Flags.consentCompleted];
            return {
                ...state,
                flags,
            };
        case `${Actions.REMOVE_FLAGS}`:
            consentFlow = false;
            return {
                ...state,
                flags: null,
            };
        case Actions.SET_PROCESS_MODES:
            return {
                ...state,
                consentProcessMode: {processModes: action.body},
            };
        case Actions.REQUEST_GET_NACH_LINK:
            return {
                ...state,
                initiationNachError: null,
                loading: true,
            }
        case `${Actions.REQUEST_GET_NACH_LINK}_SUCCESS`:
            const {mode, link, ...response} = action.body;
            let nach: INach = null;
            if (mode === "ENACH") {
                sessionStorage.setItem("eNachMode", "true");
                nach = {...nach, enachAuthLink : link, mode, ...response};
            } else if (mode === "PNACH") {
                nach = {...nach, pnachLink: link};
            }
            loanApprovalInfo = {...state.loanApprovalInfo, nach}
            flags = [nextFlag(loanApprovalInfo, state.unsignedDocBase64Str)];
            return{
                ...state,
                loanApprovalInfo,
                loading: false,
                flags,
            };
        case `${Actions.REQUEST_GET_NACH_LINK}_FAILURE`:
            const errorMsg = 'Something went wrong';
            return {
                ...state,
                loading: false,
                initiationNachError: action.body && action.body.error ?
                                        action.body.error['message'] ||
                                        (action.body.error['raw_error'] && `${action.body.error.raw_error.error.param}, ${action.body.error.raw_error.error.message}`) ||
                                        errorMsg : errorMsg,
            }
        case Actions.CLEAR_NACH_ERROR:
            return {
                ...state,
                initiationNachError: null,
            }
        case UserFormActions.SET_USER_FLAG: {
            flags = [nextFlag(state.loanApprovalInfo, state.unsignedDocBase64Str)];
            return {
              ...state,
              flags,
            };
        }
        case Actions.SHOW_CONSENT_LOADER: {
            const loading = true;
            return {
                ...state,
                loading,
            };
        }
        case Actions.HIDE_CONSENT_LOADER: {
            const loading = false;
            return {
                ...state,
                loading,
            };
        }
        case ProfileAction.CLEAR_PROFILE_INFO: {
            return defaultState;
        }
        default:
            return state;
    }
}

const isDocSubstatus = (substatuses: string[]): boolean => {
    return (substatuses && (substatuses.includes(IOppSubstatus.AADHAAR_UNCLEAR)
        || substatuses.includes(IOppSubstatus.PAN_UNCLEAR)
        || substatuses.includes(IOppSubstatus.CURR_ADDR_PROOF_REQUESTED)
        || substatuses.includes(IOppSubstatus.CHEQUE_UNCLEAR)
        || substatuses.includes(IOppSubstatus.SELFIE_UNCLEAR)));
};

export function nextFlag(loanApprovalInfo: ILoanApprovalInfo, unsignedDocBase64Str) {
    if (loanApprovalInfo != null) {
        if (loanApprovalInfo.status === "LENDER_APPROVED" || (loanApprovalInfo.status === "CUST_NOT_INTERESTED" && loanApprovalInfo?.subStatuses)) {
            return Flags.showConsentLoanDetails;
        } else if (loanApprovalInfo.status === "CUST_CONSENT_GIVEN") {
            if (loanApprovalInfo && loanApprovalInfo.subStatuses
              && loanApprovalInfo.subStatuses.includes(IOppSubstatus.PA_FORM_PENDING)) {
                return Flags.showPAForm;
            }  else if (loanApprovalInfo && loanApprovalInfo.subStatuses && loanApprovalInfo.subStatuses.includes(IOppSubstatus.KYC_PENDING) && (loanApprovalInfo.productCode === "EkagrataChotaLoan" || loanApprovalInfo.productCode === "EkagrataLoan")) {
                return Flags.oKycRedirection;
            } else if ((loanApprovalInfo
                && loanApprovalInfo.documentsConsentStatus
                && loanApprovalInfo.documentsConsentStatus.isChequeAvailable === null
                && loanApprovalInfo.amount > 4000) || (isDocSubstatus(loanApprovalInfo.subStatuses) && loanApprovalInfo.amount > 4000)) {
                return Flags.showDocConsent;
            } else if (!unsignedDocBase64Str) {
                return Flags.showTimerDelay;
            } else if (loanApprovalInfo && loanApprovalInfo.esignRequestId && !loanApprovalInfo.isEsignDone) {
                return Flags.showEsign;
            }  else if ((!unsignedDocBase64Str || loanApprovalInfo.isEsignDone) && consentFlow) {
                return Flags.consentCompleted;
            }
        } else {
            return null;
        }
    }
    return null;
}
